import { useTranslation } from "react-i18next";

// menu = abre um submenu no header ("solutions", "products" ou "cases").
export type NavItem = { label: string; to?: string; href?: string; menu?: "solutions" | "products" | "cases" };

// Fonte única dos links institucionais, usada pelo Header e pelo Footer.
export function useNavLinks() {
  const { t } = useTranslation();

  const main: NavItem[] = [
    { label: t("header.about", "Sobre nós"), to: "/sobre" },
    { label: t("header.solutions", "Soluções"), to: "/solucoes", menu: "solutions" },
    { label: t("header.products", "Produtos"), to: "/produtos", menu: "products" },
    { label: t("header.cases", "Cases"), to: "/cases", menu: "cases" },
    { label: t("header.blog", "Blog"), to: "/blog" },
    { label: t("header.work_with_us", "Trabalhe Conosco"), href: "https://calriz.vagas.solides.com.br/" },
    { label: t("header.customer_support", "Suporte ao cliente"), href: "https://ticket.calriz.com/#login" },
  ];

  const utility: NavItem[] = [
    { label: t("header.whistleblower_channel", "Canal de Denúncias"), to: "/canal-de-denuncias" },
    { label: t("header.intranet", "Intranet"), href: "https://intranet.calriz.com/" },
  ];

  const social: NavItem[] = [
    { label: "LinkedIn", href: "https://www.linkedin.com/company/calriz" },
    { label: "Instagram", href: "https://www.instagram.com/calrizig?igsh=aWJ4dm4zMDk2eHhk" },
    { label: "YouTube", href: "https://www.youtube.com/@calriz/videos" },
  ];

  return { main, utility, social };
}
